import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Contact from '../components/contact/contact_body';
import Topbar from '../components/Topbar';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("ContactUs", "contact/contact_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.ContactUs || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Contact />
    </div>
  );
};

export default Page;